import TYPES from '@/modules/shared/types';

// Domain
import { ActivateSowosModerateRepository } from '../../domain/repositories/activate-sowos-moderate-repository';
import { ActivateSowosModerateDto } from '../../domain/dto/activate-sowos-moderate-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class ActivateSowosModerateHttpRepository implements
  ActivateSowosModerateRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/activate-sowos-moderate/`;

  activate(activate_sowos_moderate_dto: ActivateSowosModerateDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', activate_sowos_moderate_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
